import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { IlenkradApi } from "redux/RTQ/IlenkradApi";
import informationSlice from "redux/informationSlice/informationSlice";
import drawerSlice from "redux/drawerSlice/drawerSlice";

const rootReducer = combineReducers({
  [IlenkradApi.reducerPath]: IlenkradApi.reducer,
  information: informationSlice.reducer,
  drawer: drawerSlice.reducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(IlenkradApi.middleware),
});

setupListeners(store.dispatch);

export default store;
